<template>
  <div class="md:mx-14 mx-4">
    <div>
      <div
        class="flex md:flex-row flex-col bg-canvas border py-4 px-3 mt-4 rounded-lg justify-center md:justify-between md:items-center"
      >
        <div class="flex items-center">
          <div class="hide-icon">
            <receive-payment-link-icon size="h-8 w-10" />
          </div>
          <div class="md:pl-5">
            <p class="text-sm pb-2 text-fg-default">Create Payment Link</p>
            <p
              style="word-break: normal"
              class="text-xs font-thin md:w-3/4 leading-none text-fg-muted"
              test-id="paymentlinkHeading"
            >
              A Payment link is a link that allows your consumer to pay you for
              your goods or service by clicking on it.
            </p>
          </div>
        </div>

        <!-- The id in the next line maps the walkthrough to that div element. Please do not remove this id -->
        <div class="py-3" id="paymentLinkItem1">
          <el-button
            class="bg-primary flex items-center text-white font-light rounded-md"
            @click="openCreatePaymentLinkDrawer"
            test-id="button"
            :disabled="!hasDepositAccess"
          >
            <div class="flex items-center">
              <span class="pr-2 pb-0.5 -mt-0.5 font-bold text-lg">+</span>
              <span> New Payment Link </span>
            </div>
          </el-button>
        </div>
      </div>
      <payment-link-table
        :tableData="paymentLinks"
        :is-loading="isLoading"
        @sort="sortHandler"
        :sort-direction="sortDirection"
      />
      <create-payment-link-drawer
        v-if="showCreatePaymentLinkDrawer"
        :showDrawer="showCreatePaymentLinkDrawer"
        @closeDrawer="closeDrawer('showCreatePaymentLinkDrawer')"
        @successfulPaymentLink="successfulPaymentLinkHandler"
      />
      <successful-payment-link
        v-if="showSuccessfulPaymentLinkDialog"
        :showDialog="showSuccessfulPaymentLinkDialog"
        @closeDialog="closeDialog('showSuccessfulPaymentLinkDialog')"
      />
      <app-tour
        :tourDetails="paymentLinkTour"
        tourComponent="paymentLink"
        :displayTour="displayTour"
        @stopTour="stopTour"
      />
      <initiate-tour-button @startTour="startPaymentLinksTour" />
    </div>
  </div>
</template>

<script>
import getPaymentLinks from '@/mixins/paymentLink.js'
import notification from '@/mixins/notification.js'
import fetchAllTours from '@/mixins/appTourApi.js'
import { PAYMENT_LINKS_TOUR } from '@/utils/constants'
import userKinds from '@/mixins/userKinds.js'

export default {
  mixins: [getPaymentLinks, fetchAllTours, notification, userKinds],
  data () {
    return {
      displayTour: false,
      paymentLinkTour: PAYMENT_LINKS_TOUR,
      sortDirection: 'default',
      isLoading: false,
      showCreatePaymentLinkDrawer: false,
      showSuccessfulPaymentLinkDialog: false,
      payload: {
        page: 1,
        size: 5,
        status: '',
        type: '',
        from: '',
        to: '',
        sort_direction_desc: true,
        sort_by: 'created_at'
      }
    }
  },
  components: {
    InitiateTourButton: () =>
      import('@/components/v2/app-tour/InitiateTourButton.vue'),
    AppTour: () => import('@/components/v2/app-tour/AppTour.vue'),
    PaymentLinkTable: () =>
      import('@/components/v2/paymentLink/tables/PaymentLinkTable.vue'),
    ReceivePaymentLinkIcon: () =>
      import('@/assets/v2/icons/ReceivePaymentLinkIcon.vue'),
    CreatePaymentLinkDrawer: () =>
      import('@/components/v2/paymentLink/drawers/CreatePaymentLinkDrawer.vue'),
    SuccessfulPaymentLink: () =>
      import('@/components/v2/paymentLink/dialogs/SuccessfulPaymentLink.vue')
  },
  methods: {
    startPaymentLinksTour () {
      this.$tours.paymentLinksTour.start()
      this.displayTour = true
    },
    stopTour () {
      this.displayTour = false
      if (this.$store.state.appTour.paymentLinkTourIsActive) {
        this.showCreatePaymentLinkDrawer = true
      }
    },
    sortHandler (sortObj) {
      if (sortObj.sortFormat === 'time') {
        this.$store.dispatch('paymentLink/sortTimeHandler', sortObj.direction)
      } else if (sortObj.sortFormat === 'amount') {
        this.$store.dispatch('paymentLink/sortAmountHandler', sortObj.direction)
      } else if (sortObj.sortFormat === 'name') {
        this.$store.dispatch('paymentLink/sortNameHandler', sortObj.direction)
      }
    },
    closeDrawer () {
      this.showCreatePaymentLinkDrawer = false
    },
    closeDialog (arg) {
      this[arg] = false
    },
    openCreatePaymentLinkDrawer () {
      this.showCreatePaymentLinkDrawer = true
    },
    successfulPaymentLinkHandler () {
      this.showCreatePaymentLinkDrawer = false
      this.showSuccessfulPaymentLinkDialog = true
    },
    async getPageDetails () {
      await this.getPaymentLinks()
      await this.getAllNotifications()
      await this.fetchAllTours()
      if (this.createPaymentLinkFromTransactions) {
        this.openCreatePaymentLinkDrawer()
      }
      if (this.isANewUser) {
        this.startPaymentLinksTour()
      }
    }
  },
  computed: {
    paymentLinks () {
      return this.$store.state.paymentLink.paymentLinks.items
    },
    isANewUser () {
      return !this.$store.state.appTour.allTours.paymentLink
    },
    createPaymentLinkFromTransactions () {
      return this.$store.state.transactions.createPaymentLinkFromTransactions
    }
  },
  async mounted () {
    await this.getPageDetails()
  }
}
</script>

<style scoped>
@media only screen and (max-width: 800px) {
  .hide-icon {
    display: none;
  }
}
</style>
